import { MODE_DEV, MODE_PROD } from 'root/settings'
import { getSchema } from '../utils'

export const ITEMS = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            productId: 'productId',
            name: 'name',
            unitQuantity: 'unitQuantity',
            unitPrice: 'unitPrice',
            unitSize: 'unitSize',
            unitGramEQ: 'unitGramEQ',
            total: 'total'
        }),
        [MODE_PROD]: Object.freeze({
            productId: 'pi',
            name: 'n',
            unitQuantity: 'uq',
            unitPrice: 'up',
            unitSize: 'us',
            unitGramEQ: 'uge',
            total: 't'
        })
    })
})()

export const DELIVERY_ADDRESS = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            address1: 'address1',
            address2: 'address2',
            postalCode: 'postalCode',
            city: 'city',
            optional: 'optional',
            province: 'province',
            country: 'country'
        }),
        [MODE_PROD]: Object.freeze({
            address1: 'a1',
            address2: 'a2',
            postalCode: 'pc',
            city: 'c',
            optional: 'o',
            province: 'p',
            country: 'co'
        })
    })
})()

export const ORDER_STEP = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            createdAt: 'createdAt',
            userId: 'userId',
            userType: 'userType',
            action: 'action',
            previousAction: 'previousAction'
        }),
        [MODE_PROD]: Object.freeze({
            createdAt: 'ca',
            userId: 'ui',
            userType: 'ut',
            action: 'a',
            previousAction: 'pa'
        })
    })
})()

export const COURIER_FEE_RULES = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            feeType: 'feeType',
            value: 'value',
            parameterField: 'parameterField',
            rangeStart: 'rangeStart',
            rangeEnd: 'rangeEnd'
        }),
        [MODE_PROD]: Object.freeze({
            feeType: 'ft',
            value: 'v',
            parameterField: 'pf',
            rangeStart: 'rs',
            rangeEnd: 're'
        })
    })
})()

export const ADMIN_FEE_RULES = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            feeType: 'feeType',
            value: 'value',
            parameterField: 'parameterField',
            rangeStart: 'rangeStart',
            rangeEnd: 'rangeEnd'
        }),
        [MODE_PROD]: Object.freeze({
            feeType: 'ft',
            value: 'v',
            parameterField: 'pf',
            rangeStart: 'rs',
            rangeEnd: 're'
        })
    })
})()

export const DELIVERY_ADMIN_FEE_RULES = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            feeType: 'feeType',
            value: 'value',
            parameterField: 'parameterField',
            rangeStart: 'rangeStart',
            rangeEnd: 'rangeEnd'
        }),
        [MODE_PROD]: Object.freeze({
            feeType: 'ft',
            value: 'v',
            parameterField: 'pf',
            rangeStart: 'rs',
            rangeEnd: 're'
        })
    })
})()

export const ORDERS = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            createdAt: 'createdAt',
            storeId: 'storeId',
            brandId: 'brandId',
            placedBy: 'placedBy',
            name: 'name',
            phoneNumber: 'phoneNumber',
            deliveryAddress: 'deliveryAddress',
            items: 'items',
            instructions: 'instructions',
            subtotal: 'subtotal',
            deliveryFee: 'deliveryFee',
            adminFee: 'adminFee',
            tax: 'tax',
            total: 'total',
            routeId: 'routeId',
            courierId: 'courierId',
            lastOrderStepActionId: 'lastOrderStepActionId',
            orderStep: 'orderStep',
            customerProfileId: 'customerProfileId',
            activeCustomerPaymentProfileId: 'activeCustomerPaymentProfileId',
            referenceTransactionId: 'referenceTransactionId',
            currentPaymentStatus: 'currentPaymentStatus',
            endOfDay: 'endOfDay',
            courierFeeRules: 'courierFeeRules',
            adminFeeRules: 'adminFeeRules',
            deliveryAdminFeeRules: 'deliveryAdminFeeRules',
            fraud: 'fraud'
        }),
        [MODE_PROD]: Object.freeze({
            createdAt: 'ca',
            storeId: 'si',
            brandId: 'bi',
            placedBy: 'pb',
            name: 'n',
            phoneNumber: 'pn',
            deliveryAddress: 'da',
            items: 'i',
            instructions: 'in',
            subtotal: 's',
            deliveryFee: 'df',
            adminFee: 'af',
            tax: 't',
            total: 'to',
            routeId: 'ri',
            courierId: 'ci',
            lastOrderStepActionId: 'losa',
            orderStep: 'os',
            customerProfileId: 'cpi',
            activeCustomerPaymentProfileId: 'acpp',
            referenceTransactionId: 'rti',
            currentPaymentStatus: 'cps',
            endOfDay: 'eod',
            courierFeeRules: 'cfr',
            adminFeeRules: 'afr',
            deliveryAdminFeeRules: 'dafr',
            fraud: 'f'
        })
    })
})()
